import './index.css';
import { jsx } from 'react/jsx-runtime';
import { cloneElement } from 'react';
import classnames from 'classnames';
import { isIconComponent, IconDynamic } from '@hh.ru/magritte-ui-icon';
import { s as styles } from './styles-BHp5I8DR.js';

const CellItem = ({ item, isRight }) => {
    const defaultProps = {};
    if (isIconComponent(item)) {
        defaultProps.initialColor = item.props.initialColor || 'secondary';
        defaultProps.disabledColor = item.props?.disabledColor || 'secondary';
        return (jsx("div", { className: classnames(styles.item, {
                [styles.itemRight]: isRight,
            }), children: jsx(IconDynamic, { children: cloneElement(item, defaultProps) }) }));
    }
    return (jsx("div", { className: classnames(styles.item, {
            [styles.itemRight]: isRight,
        }), children: item }));
};

export { CellItem };
//# sourceMappingURL=CellItem.js.map
